import { LineHelpCircle } from '@qr-front/icons/line-help-circle'
import { Button } from '@qr-front/ui/components/Button'
import { PrimitiveAtom, useAtomValue } from 'jotai'
import { useSearchParams } from 'next/navigation'
import { useTranslations } from 'next-intl'
import { useState } from 'react'

import { BUILDER_EDIT_MODES } from '@/constants'

import { qrTypeAtom } from '../generatorState'
import {
	GENERATOR_SEARCH_PARAM,
	QR_TYPE,
	TGeneratorStep,
} from '../generatorTypes'
import { useCurrGeneratorStep } from '../hooks'
import { getQrTypeTranslation } from '../utils/qrTypeData'
import { HelpDialog } from './DialogHelp'

export const GeneratorPageHeading = ({
	hasSidebar,
	pathnameMatchesTypeStep,
}: {
	hasSidebar?: boolean
	pathnameMatchesTypeStep?: boolean
}) => {
	const [isHelpPopupOpen, setIsHelpPopupOpen] = useState(false)
	const t = useTranslations()

	const currStep = useCurrGeneratorStep()

	const qrType = useAtomValue(
		qrTypeAtom as unknown as PrimitiveAtom<QR_TYPE | null>,
	)

	const editMode = !!useSearchParams().get(GENERATOR_SEARCH_PARAM.Target)
	const isChangeTypeMode =
		useSearchParams().get(GENERATOR_SEARCH_PARAM.Edit) ===
		BUILDER_EDIT_MODES.TYPE

	const contentStepHeadingTKey = editMode
		? 'generator__content_form__title__edit_mode'
		: 'generator__content_form__title'

	const designStepHeadingTKey = editMode
		? 'generator__design_form__title__edit_mode'
		: 'generator__design_form__title'

	const qrTypeTranslation = getQrTypeTranslation(t)(qrType)

	const stepToHeading = {
		type: t(
			isChangeTypeMode
				? 'generator__step_1__title__change'
				: 'generator__step_1__title',
		),
		content: t(contentStepHeadingTKey, {
			type: qrTypeTranslation,
		}),
		design: t(designStepHeadingTKey, {
			type: qrTypeTranslation,
		}),
	} satisfies Record<TGeneratorStep, string>

	return (
		<div className="hidden desktop:col-span-1 desktop:flex desktop:justify-between">
			<h1 className="type-heading-3">{stepToHeading[currStep]}</h1>
			{hasSidebar && pathnameMatchesTypeStep && (
				<>
					<Button
						visual="ghost-accent"
						onClick={() => setIsHelpPopupOpen(true)}
						className="flex gap-0.5"
					>
						<LineHelpCircle />
						<span className="type-body-small font-medium">
							{t('generator__header__help_button')}
						</span>
					</Button>
					<HelpDialog isOpen={isHelpPopupOpen} setIsOpen={setIsHelpPopupOpen} />
				</>
			)}
		</div>
	)
}
